<template>
  <b-row class="align-items-center user">
    <v-grid-column :size="2" :label="'CreditorId'">
      <div class="creditor">
        <span>{{ user.creditorId || '__' }}</span>
        <b-iconstack font-scale="1.5" @click="displaySuppliers = true">
          <b-icon stacked icon="square-fill" variant="dark" class="border rounded bg-primary"/>
          <b-icon stacked icon="square-fill" scale="0.85" variant="white"/>
          <b-icon stacked icon="square-fill" scale="0.5" shift-h="5" shift-v="2.4" rotate="45" variant="white"/>
          <b-icon stacked icon="pencil" shift-h="5" shift-v="2" variant="dark"/>
        </b-iconstack>
      </div>
    </v-grid-column>

    <v-grid-column :size="4" :label="'Email'">
      <span>{{ user.email || placeholder }}</span>
    </v-grid-column>

    <v-grid-column :size="2" :label="'FirstName'">
      <span>{{ user.firstName || placeholder }}</span>
    </v-grid-column>

    <v-grid-column :size="2" :label="'LastName'">
      <span>{{ user.lastName || placeholder }}</span>
    </v-grid-column>

    <v-grid-column :size="2" :label="'Comment'">
      <span>{{ user.comment || placeholder }}</span>
    </v-grid-column>

    <portal to="userTableModal" v-if="displaySuppliers">
      <suppliers-modal v-bind:show="displaySuppliers" :user="user" @cancel="displaySuppliers = false" />
    </portal>
  </b-row>
</template>

<script>
import SuppliersModal from '@/views/UsersView/components/SuppliersModal';
import VGridColumn from '@/components/layout/VGridColumn';

export default {
  name: 'UserRow',
  components: {
    SuppliersModal,
    VGridColumn,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: '__',
    },
  },
  data() {
    return {
      displaySuppliers: false,
    };
  },
};
</script>

<style scoped lang="scss">
.content-wrapper {
  display: flex;

  span {
    flex: 1;
  }

  .creditor {
    display: flex;
    align-items: center;
    flex: 1;

    i {
      &:hover {
        cursor: pointer;
        font-size: 1.5em;
        color: #007bff;
      }
    }
  }
}
</style>
